// extracted by mini-css-extract-plugin
export var layoutContainer = "_by-0";
export var layoutContainerNoRounding = "_by-6";
export var layoutContainerOpen = "_by-5";
export var layoutContainerResizing = "_by-1";
export var mainContent = "_by-2";
export var resizeDivider = "_by-3";
export var slidePanel = "_by-4";